import { Dropdown, MenuProps } from 'antd';
import dayjs from 'dayjs';
import { MoreIcon } from '../../../components/icons/MoreIcon';
import { TradeDocument } from '../../../interfaces/TradeDocument';

const DocumentsTableMobileCard = ({
    item,
    menuItems,
    setCurrentData
}: {
    item?: TradeDocument;
    menuItems: MenuProps['items'];
    setCurrentData: (data?: TradeDocument) => void;
}) => {
    return (
        <div className='bg-white border border-appcolorfaintnine border-b border-0 py-[20px]'>
            <div className='flex items-center justify-between'>
                <p className='text-sm text-ebony'>
                    Name tag:{' '}
                    <span className='font-semibold'>{item?.documentName}</span>
                </p>

                <Dropdown
                    menu={{
                        items: menuItems
                    }}
                    trigger={['click']}
                >
                    <button onClick={() => setCurrentData(item)}>
                        <MoreIcon />
                    </button>
                </Dropdown>
            </div>
            <p className='flex gap-[4px]  text-xs font-normal leading-[18px] text-paleSky'>
                Document type:
                <span className='font-semibold'> {item?.documentType}</span>
            </p>

            <div className='flex items-center gap-x-4 gap-y-1 flex-wrap'>
                <p className='flex gap-[4px] text-xs font-normal leading-[18px] text-paleSky'>
                    Data type:
                    <span className='font-semibold'> {item?.documentType}</span>
                </p>
                <p className='text-xs font-normal leading-[18px] text-paleSky'>
                    Date Added:
                    <span className='font-semibold'>
                        {dayjs(Number(item?.createdDate)).format('ll')}
                    </span>
                </p>
            </div>
            <p className='text-xs font-normal leading-[18px] text-paleSky'>
                Last modified:
                <span className='font-semibold'>
                    {dayjs(Number(item?.lastModifiedDate)).format('ll')}
                </span>
            </p>
        </div>
    );
};

export default DocumentsTableMobileCard;
